import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./HuiNoResults.scss";
import { Paragraph, Header, Icon, Button } from "../index";
import { Segment, Image } from "semantic-ui-react";

export const HuiNoResults = ({
  title = "No Results",
  subtitle,
  buttonText,
  buttonUrl,
  innerWidth = 387,
  imageSrc,
  ...props
}) => {
  return (
    <div className="hireart-ds-no-result">
      <Segment placeholder {...props}>
        <div className="inner-content" style={{ maxWidth: innerWidth }}>
          {imageSrc && (
            <Image className="img-placeholder" src={imageSrc} centered />
          )}
          <Header size="h4">{title}</Header>
          <Paragraph size="small" text={subtitle} />
          {buttonText && (
            <Button as={Link} to={buttonUrl || "#"} primary>
              {buttonText}
            </Button>
          )}
        </div>
      </Segment>
    </div>
  );
};

HuiNoResults.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  innerWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

